var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui bulleted list"},_vm._l((_vm.summaryItems),function(item){return _c('div',{staticClass:"list-item"},[_c('span',{domProps:{"innerHTML":_vm._s(item)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }